import * as React from 'react';
import Button from '@mui/material-next/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from "prop-types";
import { IconButton,FormControlLabel, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import Stack from '@mui/material/Stack';
import BlurryDialog from '../../../widget/BlurryDialog';


const KanbanConfirmCampaingEndDialog = (props) => {
  const { t } = useTranslation();

  const descriptionElementRef = React.useRef(null);


  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <BlurryDialog
      open={props.open}
      onClose={props.handleClose}
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="color color-medium-red">
        <b>
          {t("kanban.endCampaign")}
        </b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >

          <Stack spacing={3}>
            <div>
              {t('kanban.thisWillEndTheCampaignAreYouSure')}
            </div>
          </Stack>

        </DialogContentText>
      </DialogContent>
      <DialogContent>
        <DialogActions>
          <Button
            variant="filled"
            disableElevation
            className="bg bg-medium-red"
            type="submit"
            size="small"
            style={{ borderRadius: '10px' }}
            onClick={props.handleSubmit}
          >
            {t("confirm")}
          </Button>
        </DialogActions>
      </DialogContent>
    </BlurryDialog>

  );
}

KanbanConfirmCampaingEndDialog.propTypes = {
  campaignId: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  dontShowAgain: PropTypes.bool
};

export default KanbanConfirmCampaingEndDialog;